import { darkTheme as e, lightTheme as t } from "../theme/theme.mjs";
import { TooltipProvider as n } from "../components/Tooltip/Tooltip.mjs";
import { ContextualDrawer as r } from "../components/Drawer/ContextualDrawer.mjs";
import { Toaster as i } from "../components/Toast/Toast.mjs";
import { GlobalStyles as a } from "../theme/GlobalStyles.mjs";
import { createContext as o, useContext as s, useEffect as c, useState as l } from "react";
import { StyleSheetManager as u, ThemeProvider as d } from "styled-components";
import { useLocale as f } from "@maat/store-i18n";
import { jsx as p, jsxs as m } from "react/jsx-runtime";
import h from "stylis-plugin-rtl";
//#region src/RootContext/RootContext.tsx
var g = o({
	mode: "light",
	toggleTheme: () => {},
	setTheme: () => {},
	contextualDrawer: {
		state: "hidden",
		setState: () => {},
		content: null,
		setContent: () => {}
	}
}), _ = "maat-theme", v = ({ children: o, defaultMode: s = "light" }) => {
	let [v, y] = l(() => {
		if (typeof window > "u") return s;
		let e = localStorage.getItem(_);
		return e === s ? e : s;
	});
	c(() => {
		localStorage.setItem(_, v), document.documentElement.setAttribute("data-theme", v);
	}, [v]);
	let [b, x] = l("hidden"), [S, C] = l(null), w = () => y((e) => e === "light" ? "dark" : "light"), T = (e) => y(e), E = v === "dark" ? e : t, { dir: D } = f();
	return /* @__PURE__ */ p(g.Provider, {
		value: {
			mode: v,
			toggleTheme: w,
			setTheme: T,
			contextualDrawer: {
				state: b,
				setState: x,
				content: S,
				setContent: C
			}
		},
		children: /* @__PURE__ */ p(u, {
			stylisPlugins: D === "rtl" ? [h] : [],
			children: /* @__PURE__ */ m(d, {
				theme: E,
				children: [/* @__PURE__ */ p(a, {}), /* @__PURE__ */ p(n, { children: /* @__PURE__ */ m(i, { children: [o, /* @__PURE__ */ p(r, {
					state: b,
					setState: x,
					content: S
				})] }) })]
			})
		}, D)
	});
}, y = () => s(g);
//#endregion
export { v as RootProvider, y as useRootContext };
